export const extractStartTime = (markName: string): number =>
	(performance.getEntriesByName(markName, 'mark')[0] || { startTime: 0 }).startTime;
